import React from 'react';
import { StaticPage } from '../StaticPage';

export const ImprintPage: React.FC = () => (
  <StaticPage titleKey="static.imprint">
    <h2>Angaben gemäß § 5 ECG / § 25 MedienG</h2>
    <p>
      <strong>Event Partner Austria Verein</strong><br />
      Kwizdastrasse 9/11<br />
      2100 Korneuburg<br />
      Österreich
    </p>
    <p>
      E-Mail: <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
    </p>

    <h2>Haftung für Inhalte</h2>
    <p>
      Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
      Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
    </p>

    <h2>Haftung für Links</h2>
    <p>
      Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
      Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.
    </p>
  </StaticPage>
);
